export const STUDENT_CLUSTER_SUMMARY_DICTIONARY = {
  students: "Students",
} as const;
